/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

type RequiredCategory = "required" | "requiredNotFound" | "optional";
type NormalizedValueType = "text" | "date" | "checkbox";
type Entity = {
  type: string;
  properties: Entity[];
};

export class EntityLabel {
  label: string;
  requireCategory?: RequiredCategory;
  labelDescription?: string;
  normalizedValueType?: NormalizedValueType;
  nestedEntityLabels?: EntityLabel[];
  validationFunction?: string;


  constructor(label: string) {
    this.label = label;
  }

  static fromJson(json: any): EntityLabel {
    const entityLabel = new EntityLabel(json.label);
    if (json.requireCategory) {
      entityLabel.requireCategory = json.requireCategory;
    }
    if (json.labelDescription) {
      entityLabel.labelDescription = json.labelDescription;
    }
    if (json.normalizedValueType) {
      entityLabel.normalizedValueType = json.normalizedValueType;
    }
    if (Array.isArray(json.nestedEntityLabels)) {
      entityLabel.nestedEntityLabels = [];
      json.nestedEntityLabels.forEach((nestedEntityLabel: any) => {
        entityLabel.nestedEntityLabels?.push(
          EntityLabel.fromJson(nestedEntityLabel)
        );
      });
    }
    if (json.validationFunction) {
      entityLabel.validationFunction = json.validationFunction;
    }
    return entityLabel;
  }
}

// get entity labels for entity dropdown list from list of document entities
export function convertEntitiesToEntityLabels(
  entities: Entity[]
): EntityLabel[] {
  let entityLabels: EntityLabel[] = [];
  entities?.forEach((entity: Entity) => {
    if (
      !entityLabels.some((entityLabel) => entityLabel.label === entity.type)
    ) {
      let entityLabel = new EntityLabel(entity.type);
      if (entity.properties?.length > 0) {
        const nestedEntityLabels = convertEntitiesToEntityLabels(
          entity.properties
        );
        entityLabel.nestedEntityLabels = nestedEntityLabels;
      }
      entityLabels.push(entityLabel);
    }
  });
  return entityLabels;
}
